import dayjs from 'dayjs'

export function formatTime(time?: string | number, format = 'YYYY-MM-DD HH:mm:ss'): string {
  if (!time) {
    return dayjs().format(format)
  }

  // 处理时间戳
  if (typeof time === 'number') {
    // 根据位数判断是秒还是毫秒时间戳
    return String(time).length > 10
      ? dayjs(time).format(format) // 毫秒
      : dayjs.unix(time).format(format) // 秒
  }

  return dayjs(time).format(format)
}

export function formatThreeNumber(num: number): string {
  return num.toLocaleString('en-US')
}

export function formatNumberToUnit(num: number): string {
  if (num >= 1_000_000_000) {
    return `${(num / 1_000_000_000).toFixed(2)}B`
  }
  else if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(2)}M`
  }
  else if (num >= 1_000) {
    return `${(num / 1_000).toFixed(2)}K`
  }
  else {
    return num.toFixed(2)
  }
}
